 
<div class="page">
<router-outlet></router-outlet>
<app-login-notification-modal></app-login-notification-modal>
<app-chatbot></app-chatbot>
</div>

<!-- Maintenance Modal Overlay -->
<div class="maintenance-overlay" *ngIf="showMaintenanceModal">
  <div class="maintenance-card">
    <div class="maintenance-icon">
      <i class="material-symbols-outlined">engineering</i>
    </div>
    <h2>Scheduled Maintenance</h2>
    <p class="maintenance-message">{{ maintenanceMessage }}</p>
  </div>
</div>
 